/**
 * Profile-related service functions. The current user is always derived
 * from the JWT on the server, so callers don't pass a userId.
 */
import { apiClient } from '@/lib/api-client';

export async function fetchProfile() {
  return apiClient.get('/profiles');
}

export async function updateProfile(updates: Record<string, unknown>) {
  await apiClient.patch('/profiles', updates);
}
